// 安心安全メールの使い方ページ

/*-------------------
    モジュールのimport
---------------------*/
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
/*-------------------
    classのimport
---------------------*/
import * as commons from '../commons';
import Footer from '../components/Footer';
/*-------------------
    cssのimport
---------------------*/
import '../css/safety.css';

// クラス名
class SafetyHowTo extends Component {
  constructor(props) {
    super(props);

    // URLから安心安全メールのコードを取得。
    const url = props.location.pathname;
    const num = url.lastIndexOf('/');
    const cryptUrl = url.slice(num + 1);
    this.state = { cryptUrl };
  }

  componentDidMount = async () => {
    const { cryptUrl } = this.state;

    // サイト情報を取得する。
    const resData = await commons.siteSetting(cryptUrl);
    const { setting, footer } = resData;

    if (setting === true) return;
    if (setting.length === 0) {
      commons.moveErrorPage(this.props, '10');
      return;
    }

    const { site_info: siteInfo, lcl_gov: lclGov } = setting[0];
    const { lg_cd: lgCd = '' } = lclGov;
    const { name: siteName = '' } = siteInfo;

    // アカウント情報を取得する。
    const accountSetting = await commons.commonSetting({
      lgCd,
      enable: true,
      colName: 'M_ACCOUNT',
      kind: '2',
    });
    const { account_info: accountInfo } = accountSetting[0];
    const { host_name: hostName } = accountInfo;

    document.title = `${siteName}`;

    this.setState({ footer, siteName, hostName });
  };

  onClickBtnMove = (path) => {
    const { cryptUrl } = this.state;
    const { history } = this.props;
    history.push({ pathname: `${path}/${cryptUrl}` });
  };

  render() {
    const { siteName, hostName, footer = '' } = this.state;

    const torokuMail = <a href={`mailto:regist@${hostName}?subject=regist`}>空メール</a>;
    const kaizyoMail = <a href={`mailto:unsubscribe@${hostName}?subject=regist`}>空メール</a>;

    if (footer === '') return true;

    return (
      <div id="safety-container">
        <div className="safety-back">
          <div className="safety-title">{siteName}</div>
          <div className="safety-content">
            <div className="safety-top">メールアドレス登録手順</div>
            <ol className="safety-howto">
              <li>最初に{torokuMail}を送信します。（メールアドレスが仮登録されます）</li>
              <li>
                その直後に登録確認メールが送られてきますので、そのメールに記載されておりますURL(ホームページアドレス)にアクセスします。
              </li>
              <li>確認ページが表示されますので登録を完了させます。</li>
              <li>その後、情報が発信された場合に{siteName}として送られてきます。</li>
            </ol>
            <div className="safety-top mt20">メールアドレス解除手順</div>
            <ol className="safety-howto">
              <li>最初に{kaizyoMail}を送信します。</li>
              <li>
                その直後に解除確認メールが送られてきますので、そのメールに記載されておりますURL(ホームページアドレス)にアクセスします。
              </li>
              <li>確認ページが表示されますので登録解除を完了させます。</li>
            </ol>
            <div className="safety-fot">
              <button
                type="button"
                className="btnAtag mt20"
                onClick={() => {
                  this.onClickBtnMove('../home');
                }}
              >
                トップページに戻る
              </button>
              {footer}
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

SafetyHowTo.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default withRouter(SafetyHowTo);
